import { experiment } from "@faire/web/common/settings/declarations/experiment";

/**
 * FE_DISCOVER_PAGE_SECTIONAL_DESIGN_V2
 */
export const FE_DISCOVER_PAGE_SECTIONAL_DESIGN_V2_250708 = experiment({
  name: "FE_DISCOVER_PAGE_SECTIONAL_DESIGN_V2_250708",
  identifier: "SignUpSessionToken",
  client: ["VISITOR_WEB", "RETAILER"],
  notifyAfter: "2025-08-01",
  defaultValue: false,
  productArea: "LOGGED_OUT_RETAILERS",
});
